import AreaContainer from "../AreaContainer";
import AgentsList from "./AgentsList";
import UpgradeProperty from "../UpgradeProperty";
import LocalAgents from "./LocalAgents";
import styles from './agents.module.css';

interface Props {
  sponsored: boolean;
  isLDC: boolean;
  owners: any;
  agents: any;
  centre_managers: any;
  asset_managers: any;
  id: any;
  name: string;
  docType: string;
  local_agents: any;
  title: string;
  isLoggedIn: boolean;
  unfilteredAgents: any;
  payingClient: boolean;
  contactable: boolean;
  bid: boolean
  showAllAgentContacts: boolean;
  setShowAllAgentContacts: any;
  showPage: boolean;
}
const Agents = ({ setShowAllAgentContacts, showAllAgentContacts, agents = [], owners = [], centre_managers = [], asset_managers = [], sponsored = false, isLDC = false, id, name, docType, local_agents, title, isLoggedIn, unfilteredAgents, payingClient, contactable, bid, showPage }: Props) => {

  let noContacts = agents.length == 0 && centre_managers !== null && centre_managers.length == 0 && asset_managers.length == 0 && owners.length == 0;

  let agentsContactable = !contactable && !bid && !sponsored && !payingClient;

  return (
    <AreaContainer area="agents" style={null} extraClass={null}>
      <div className={styles.AgentDetailsContainer}>
        {agents && agents.length > 0 && <AgentsList showAllAgentContacts={showAllAgentContacts} agents={agents} contactable={!agentsContactable} sponsored={sponsored} id={id} type={docType} display="agents" title={""}/>}
        {centre_managers && centre_managers.length > 0 && <AgentsList showAllAgentContacts={false} title="Centre Managers" sponsored={sponsored} agents={centre_managers} contactable={true} id={id} type={docType} display="centre_managers" />}
        {asset_managers && asset_managers.length > 0 && <AgentsList showAllAgentContacts={false} title="Asset Managers" sponsored={sponsored} agents={asset_managers} contactable={true} id={id} type={docType} display="asset_managers" />}
        {owners && owners.length > 0 && <AgentsList showAllAgentContacts={false} title="Owner" agents={owners} sponsored={sponsored} contactable={false} id={id} type={docType} display="owner" />}

      </div>
      {noContacts && (local_agents && local_agents.length === 0) && (unfilteredAgents && unfilteredAgents.length === 0) && <UpgradeProperty type={docType} id={id} name={name} noContacts={true} />}
      {noContacts && ((local_agents && local_agents.length > 0) || (unfilteredAgents && unfilteredAgents.length > 0)) && <LocalAgents unfilteredAgents={unfilteredAgents} agents={local_agents} id={id}  isLoggedIn={isLoggedIn} payingClient={payingClient} type={docType} showPage={showPage} />}
    </AreaContainer>
  );
};

export default Agents;
